import instance from "./instance";


export const insertPermission = () => instance.get(`insertpermissions`)

export const insertPermissionByOrgId = (id:any) => instance.get(`insertorgmodulepermissions/${id}`)

export const getAllPermissionList =()=>instance.get(`permissions`)